import { render } from "./edit.html?vue&type=template&id=d4fe0254&ts=true&external"
import script from "./edit.ts?vue&type=script&lang=ts&external"
export * from "./edit.ts?vue&type=script&lang=ts&external"

import "./edit.scss?vue&type=style&index=0&lang=scss&external"
import "@vueform/toggle/themes/default.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__